import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconEye32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconEye32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M26.713 16.164c-.61 1.184-1.815 3.19-3.64 4.878C21.267 22.713 18.94 24 16 24s-5.267-1.287-7.073-2.958c-1.825-1.688-3.03-3.694-3.64-4.878a.34.34 0 0 1 0-.328c.61-1.184 1.815-3.19 3.64-4.878C10.733 9.287 13.06 8 16 8s5.267 1.287 7.073 2.958c1.825 1.688 3.03 3.694 3.64 4.878a.34.34 0 0 1 0 .328m-23.204.917a2.34 2.34 0 0 1 0-2.162C4.842 12.333 8.838 6 16 6s11.158 6.333 12.491 8.92a2.34 2.34 0 0 1 0 2.16C27.158 19.668 23.162 26 16 26S4.842 19.667 3.509 17.08m11.585 2.3a3.5 3.5 0 0 1-2.475-4.287 1 1 0 0 0-1.931-.518 5.5 5.5 0 1 0 3.888-3.89 1 1 0 1 0 .52 1.932 3.5 3.5 0 1 1-.001 6.763"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconEye32);
